import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  // technologies
  tech_iOS: string = 'ios';
  tech_Android: string = 'android';

  // states
  state_success: string = 'success';
  state_loading: string = 'loading';
  state_error: string = 'error';

  //app status
  app_status_dev: string = 'DEVELOPMENT';
  app_status_live: string = 'LIVE';
  app_status_deco: string = 'DECOMMISSIONED';

  // type
  appType_Native: string = 'native';
  appType_Hybrid: string = 'hybrid';
  appType_WhiteLabel: string = 'whitelabel';

  // sort by
  sortBy_Asc = 'asc';
  sortBy_Desc = 'desc';
  sortBy_LastChange = 'lastChange';
  sortBy_LastStoreUpdate = 'latest_store_update_date';
  sortBy_CreatedRecently = 'onboard_date';
  sortBy_LastCodeUpdate = 'latest_commit_date';
  sortBy_FasterTimeToMarket = 'lead_time';

  //app tab options
  appDataTabInfo = 'app-info';
  appDataTabUserAccess = 'user-access';
  appDataTabTools = 'app-tools';
  appDataTabCloseIssues = 'close-issues';
  appDataTabCompliace = 'compliance';
}
